<template>
    <b-modal
        id="modalRahtEmpresa"
        v-model="mostrarModalForm"
        @show="preencherForm()"
        @hide="$emit('modalFechado')"
        :no-close-on-backdrop="true"
    >
        <div slot="modal-title">
            Empresa
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <!-- <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box> -->
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Tipo do Documento</label>
                    <b-form-select
                        :plain="true"
                        :options="tiposDocumentosOptions"
                        v-model="tipoDocumento"
                        :disabled="tipo == 'A'"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Documento</label>
                    <b-form-input
                        v-if="tipo == 'A'"
                        :disabled="tipo == 'A'"
                        type="text"
                        v-model="documento2"
                        v-mask="tipoDocumentoMask"
                    ></b-form-input>
                    <b-form-input
                        v-if="tipo == 'I'"
                        type="text"
                        v-model="documento"
                        @input.native="$v.documento.$touch()"
                        :state="$v.documento.$error ? false : null"
                        v-mask="tipoDocumentoMask"
                    ></b-form-input>
                    <b-form-invalid-feedback
                        >Documento é obrigatório</b-form-invalid-feedback
                    >
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Nome</label>
                    <b-form-input
                        type="text"
                        v-model="nome"
                        @input="$v.nome.$touch()"
                        :state="$v.nome.$error ? false : null"
                    ></b-form-input>
                    <b-form-invalid-feedback
                        >O nome da empresa é
                        obrigatório</b-form-invalid-feedback
                    >
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Quantidade de Horas</label>
                    <b-form-input
                        type="number"
                        v-model="qtdHoras"
                        @input="$v.qtdHoras.$touch()"
                        :state="$v.qtdHoras.$error ? false : null"
                        v-mask="'######'"
                    ></b-form-input>
                    <b-form-invalid-feedback
                        >A quantidade de horas é
                        obrigatória</b-form-invalid-feedback
                    >
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModalForm()"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                :disabled="
                    this.tipo == 'I'
                        ? $v.$invalid
                        : $v.nome.$invalid || $v.qtdHoras.$invalid
                "
                @click.stop="confirmarSalvar()"
                class="ml-1"
                >Salvar</b-button
            >
        </div>
    </b-modal>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        empresa: {
            type: Object,
            default: () => ({})
        },

        tipo: {
            type: String,
            default: () => 'I'
        },

        mostrarModal: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            mostrarModalForm: false,
            documento: '',
            documento2: '',
            nome: '',
            qtdHoras: 0,
            tipoDocumento: 'CNPJ',
            tiposDocumentos: [
                { tipo: 'CNPJ', mask: '##.###.###/####-##' },
                { tipo: 'CPF', mask: '###.###.###-##' },
                { tipo: 'DAP', mask: 'XXXXXXXXXXXXXXXXXXXXXXXXX' },
                { tipo: 'NIRF', mask: '#.###.###-#' },
                { tipo: 'SICAB', mask: 'AA.####.#######.##' }
            ]
        }
    },

    computed: {
        operacao() {
            switch (this.tipo) {
                case 'I':
                    return 'INSERÇÃO'
                case 'A':
                    return 'ATUALIZAÇÃO'
                default:
                    return 'INDEFINIDO'
            }
        },

        tiposDocumentosOptions() {
            return this.tiposDocumentos.map(t => {
                return t.tipo
            })
        },

        tipoDocumentoMask() {
            return this.tiposDocumentos.find(t => t.tipo == this.tipoDocumento)
                .mask
        }
    },

    methods: {
        fecharModalForm() {
            this.resetForm()
            this.$emit('modalFechado')
        },

        resetForm() {
            this.mostrarModalForm = false
            this.erros = []
            this.documento = ''
            this.tipoDocumento = 'CNPJ'
            this.nome = ''
            this.qtdHoras = 0
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            if (this.tipo == 'I') {
                this.documento = ''
                this.nome = ''
                this.qtdHoras = 0
            } else if (this.tipo == 'A') {
                this.tipoDocumento = this.empresa.tipoDocumento
                this.nome = this.empresa.nome
                this.qtdHoras = this.empresa.qtdHoras
                this.documento2 = this.empresa.documento.apenasLetrasNumeros()
            }
        },

        confirmarSalvar() {
            this.salvar()
            // this.mostrarModalForm = false
            // this.$swal({
            //     title: 'Empresa Atendida',
            //     html: `Confirma a ${
            //         this.tipo == 'I' ? 'inserção' : 'atualização'
            //     } da empresa ${this.nome.toUpperCase()}?`,
            //     icon: 'warning',
            //     showCancelButton: true,
            //     confirmButtonColor: '#3085d6',
            //     cancelButtonColor: '#d33',
            //     confirmButtonText: 'Sim',
            //     cancelButtonText: 'Não'
            // }).then(result => {
            //     if (result.value) {
            //         this.salvar()
            //     } else {
            //         this.mostrarModalForm = true
            //     }
            // })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let empresaDto = {
                documento:
                    this.tipo == 'I'
                        ? this.documento.apenasLetrasNumeros()
                        : this.documento2.apenasLetrasNumeros(),
                tipoDocumento: this.tipoDocumento,
                nome: this.nome.toUpperCase(),
                qtdHoras: this.qtdHoras
            }
            if (this.tipo == 'A') {
                this.$emit('atualizarEmpresa', empresaDto)
            } else {
                this.$emit('inserirEmpresa', empresaDto)
            }

            this.registroSalvoComSucesso()
            this.$store.dispatch('removeRequest')
        },

        registroSalvoComSucesso() {
            this.fecharModalForm()
        }
    },

    watch: {
        mostrarModal() {
            this.mostrarModalForm = this.mostrarModal
        },

        tipoDocumento() {
            this.documento = ''
        }
    },

    validations: {
        documento: {
            required,
            documentoValido(value) {
                if (value) {
                    if (this.tipoDocumento == 'CPF') {
                        let n = value.apenasNumeros()
                        return this.$cpfValido(n)
                    } else if (this.tipoDocumento == 'CNPJ') {
                        let n = value.apenasNumeros()
                        return this.$cnpjValido(n)
                    } else if (this.tipoDocumento == 'DAP') {
                        let n = value.apenasLetrasNumeros()
                        return n.length == 25
                    } else if (this.tipoDocumento == 'NIRF') {
                        let n = value.apenasNumeros()
                        return n.length == 8
                    } else if (this.tipoDocumento == 'SICAB') {
                        let n = value.apenasLetrasNumeros()
                        return n.length == 15
                    } else {
                        return true
                    }
                }
                return true
            }
        },
        qtdHoras: {
            required,
            minValue: minValue(1)
        },
        nome: {
            required
        }
    }
}
</script>
